import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const NewsPage = () => {
  // Mock news data
  const newsItems = [
    {
      id: 1,
      title: "The New Upgrades",
      date: "April 29, 2025",
      category: "Releases",
      image: "/api/placeholder/400/300",
      summary: ">>>",
      content: "Welcome To The New Site, new with oiled cogs."
    },
  ];

  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <div className="mystical-card">
            <h1 className="mystical-title text-black mb-8">
              Latest News & Updates
            </h1>
            
            <div className="mystical-card bg-white bg-opacity-95 mb-8">
              <h2 className="mystical-subtitle text-black text-2xl mb-6">
                Stay Informed
              </h2>
              <p className="mystical-text text-black text-lg">
                Keep up with the latest releases, events, and community highlights. Our news section is updated regularly with all the information collectors need to know.
              </p>
            </div>

            {/* News Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
              {newsItems.map((item) => (
                <div key={item.id} className="mystical-card group transition-all duration-300">
                  <img 
                    src={item.image} 
                    alt={item.title} 
                    className="w-full h-48 object-cover rounded-t-lg mystical-glow" 
                  />
                  <div className="p-4">
                    <h3 className="mystical-subtitle text-black text-xl mb-2">{item.title}</h3>
                    <div className="mystical-text text-gray-600 text-sm mb-2">{item.date} • {item.category}</div>
                    <p className="mystical-text text-gray-700 italic mb-2">{item.summary}</p>
                    <p className="mystical-text text-gray-600 mb-4">{item.content}</p>
                    <Link 
                      to={`/news/${item.id}`} 
                      className="mystical-button w-full text-center"
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            {/* Upcoming Events */}
            <div className="mystical-card">
              <h2 className="mystical-subtitle text-black text-2xl mb-6">
                Upcoming Events
              </h2>
              
              <div className="space-y-4">
                <div className="mystical-card bg-purple-500 bg-opacity-10">
                  <h3 className="mystical-subtitle text-gray-800 text-xl mb-2">TEMP</h3>
                  <p className="mystical-text text-gray-600">TEMP</p>
                </div>
              </div>
              
              <div className="mt-6 text-center">
                <Link 
                  to="/events" 
                  className="mystical-button"
                >
                  View Full Calendar
                </Link>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-wrap justify-center gap-4 mt-8">
              <Link to="/" className="mystical-button">
                Return Home
              </Link>
              <Link to="/guide" className="mystical-button">
                View Guides
              </Link>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default NewsPage;